import { GridColDef, GridRowId, GridRowParams, GRID_CHECKBOX_SELECTION_COL_DEF, GridValidRowModel } from '@mui/x-data-grid-premium';
import { useGetAllProducts, useGetDiscontinuedProducts } from '../../api/requestConfigs/products';
import React, { useEffect, useMemo, useState } from 'react';
import tableHelper from 'src/utils/tableHelper';
import { tableSettingsProps, useCompleteTableSettings, useInitialTableSettings, useTableSettings } from '../tableSettings/useTableSettings';
import { ID_FIELD_PRODUCTS } from 'src/utils/idFields';
import useUpdateEffect from '../../useUpdateEffect';
import { getAttributesForProducts, getLowOrderPoints, getWarehouseStockById } from 'src/utils/apiRequests';
import { useSettingsContext } from '../../useSettings';
import { getNestedValue } from 'src/utils/settings';
import { useExtraColumn, useExtraColumnPaginated } from '../tableSettings/useAdditionalDataCell';
import { useGetWarehouses } from '../../api/requestConfigs/warehouse';
import {
  extractLowOrderPointCellData,
  extractLowOrderPointIdCellData,
  extractWarehouseStockCellData,
  extractAttributesCellData,
  transformProductAttributes
} from 'src/utils/additionalColumns';






export const useProductsTable = (includeDiscontinued: boolean): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows: activeRows, status: activeStatus } = useGetAllProducts();
  const { rows: discontinuedRows, status: discontinuedStatus } = useGetDiscontinuedProducts(includeDiscontinued);
  console.log("Rows:", discontinuedRows,activeRows);
  const rows = useMemo(() => {
    if (!includeDiscontinued) return activeRows;
    return tableHelper.mergeById(activeRows, discontinuedRows, "ProductId");
  }, [includeDiscontinued, activeRows, discontinuedRows]);

  const status = includeDiscontinued ? (discontinuedStatus === "success" ? activeStatus : discontinuedStatus) : activeStatus;

  const initialTableSettings = useInitialTableSettings({
    tableName: "ProductTable",
    idPath: ["ProductId"],
    checkboxSelection: false,
    disableSelectionOnClick: true,
    status,
  }, rows);

  const columns: GridColDef[] = productColumns(rows, initialTableSettings);
  const tableSettings = useCompleteTableSettings({ columns }, initialTableSettings);
  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      Manufacturer_Key: false,
      ProductStatus_Key: false,
      ProductSubClass_Value: false,
      ProductLine_Value: false,
      ProductLine_Key: false,
      ProductClass_Value: false,
      VariantCount: false,
      IsPhysical: false,
      IsDigital: false,
      IsCustomerSpecific: false,
    });
  }, []);
  
  return [columns, tableSettings];
};



export const productColumns = (rows, tableSettings):  GridColDef[] => {
  // const manufacturerOptions = tableHelper.getSelectOptionsFromKeyValuePair(rows, "Manufacturer");
  // const productTypeOptions = tableHelper.getSelectOptionsFromKeyValuePair(rows, "ProductType");
  // const statusOptions = tableHelper.getSelectOptionsFromKeyValuePair(rows, "ProductStatus");
  // const productLineOptions = tableHelper.getSelectOptions(rows, "ProductLine");

  const additionalData = {};
  const additionalDataDefaults = { rows: rows, tableName: "ProductTable" };
  

// useExtraColumn({ columnName: "LowOrderPoints", requestFunction: getLowOrderPoints, requestValues: null, extractCellData: extractLowOrderPointCellData }, additionalDataDefaults, additionalData);
// useExtraColumn({ columnName: "LowOrderPointsIds", requestFunction: getLowOrderPoints, requestValues: null, extractCellData: extractLowOrderPointIdCellData }, additionalDataDefaults, additionalData);

// const warehouses = useGetWarehouses();

// useExtraColumn({ columnName: "WarehouseStock", requestFunction: getWarehouseStockById, requestValues:"1001", extractCellData: extractWarehouseStockCellData}, additionalDataDefaults, additionalData);
// useExtraColumnPaginated({ columnName: "Attributes", requestFunction: getAttributesForProducts, requestValues: null, extractCellData: extractAttributesCellData, transformFn: transformProductAttributes }, additionalDataDefaults, additionalData, 1000, "ProductId");
//   const warehouseColumns = warehouses?.map(warehouse => ({
//     field: `WarehouseStock_${warehouse?.WarehouseId}`,
//     headerName: `${warehouse?.WarehouseName} Warehouse Stock`,
//     valueGetter: additionalData['WarehouseStock']?.additionalDataCell,
//     width: 150
//   })) ?? [];
//   const warehouseColumns2 = warehouses?.map(warehouse => ({
//     field: `WarehouseStock_${warehouse?.WarehouseId}_Total`,
//     headerName: `${warehouse?.WarehouseName} Warehouse Stock Total`,
//     valueGetter: additionalData['WarehouseStock']?.additionalDataCell,
//     width: 150
//   })) ?? [];

  //console.log(additionalData)


  const columnsArray:GridColDef[] = [
    { field: 'actions', 
    getActions: (params) => tableHelper.buttonColumn(params, "Edit", "/products/products/edit?id=", "ProductId", "Edit Product"),
     type: 'actions', headerName: 'Edit', minWidth: 80, maxWidth: 120, flex: 0.8, },
    // {
    //   field: 'actions', getActions: (params, index) => {
    //     return [
    //       ...tableHelper.buttonColumn(params, "Edit", "/products/products/edit?id=", "ProductId", "Edit Product"),
    //       tableHelper.DiscardChangesButton(tableSettings, params, index)
    //     ]
    //   }, type: 'actions', headerName: 'Edit', minWidth: 90,  flex: 0.8,
    // },
    { field: 'ProductId', width: 75, headerName: 'Id', hideable: false,  },

    { field: 'Name', editable: false, headerName: 'Name', minWidth: 280, width: 280,  flex: 2, },
    
    { field: 'ProductStatus_Value',  headerName: 'Status',valueGetter: tableHelper.getFieldKeyOrValue,  renderCell: tableHelper.renderStatusCell, type: 'singleSelect', valueOptions: tableHelper.STATUSES.PRODUCTS },
    { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue, groupingValueGetter: tableHelper.getFieldKeyOrValue, width: 130, },// type:"singleSelect", valueOptions: productTypeOptions, getApplyQuickFilterFn: undefined },
    
    { field: 'Manufacturer_Value',  headerName: 'Manufacturer', valueGetter: tableHelper.getFieldKeyOrValue,minWidth: 150, maxWidth: 200 },// getApplyQuickFilterFn: undefined, valueOptions: manufacturerOptions,  type: 'singleSelect', },
    { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id', width: 190, minWidth: 180 },
    { field: 'CountryOfOrigin_Value',  headerName: 'Country Of Origin', valueGetter: tableHelper.getFieldKeyOrValue, width: 150 },
    { field: 'TARIC', headerName: 'TARIC', width: 140, minWidth: 130, maxWidth: 150 },
    
    //{ field: 'Attributes', headerName: "Attributes", valueGetter: additionalData['Attributes']?.additionalDataCell, flex:1},
    //...warehouseColumns,
    //...warehouseColumns2,
    { field: 'ValidFrom', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid From', width: 115, minWidth: 110, maxWidth: 130 },
    { field: 'ValidTo', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid To', width: 115, minWidth: 110, maxWidth: 130 },
    // { field: 'LowOrderPoints', headerName: "Low Order Points", valueGetter: additionalData['LowOrderPoints'].additionalDataCell, width: 400 },
    { field: 'Manufacturer_Key', headerName: 'Manufacturer Id', valueGetter: tableHelper.getFieldKeyOrValue, type:"number" },
    { field: 'ProductStatus_Key', headerName: 'Status Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 80, minWidth: 70, maxWidth: 100 },
    { field: 'ProductSubClass_Value', headerName: 'Product Subclass', valueGetter: tableHelper.getFieldKeyOrValue, width: 130, minWidth: 100, maxWidth: 150 },
    { field: 'ProductLine_Value', headerName: 'Product Line', valueGetter: tableHelper.getFieldKeyOrValue, type: 'singleSelect', width: 180,},// getApplyQuickFilterFn: undefined, valueOptions: productLineOptions, },
    { field: 'ProductLine_Key', headerName: 'Product Line Id', valueGetter: tableHelper.getFieldKeyOrValue, type:"number", },
    { field: 'ProductClass_Value', headerName: 'Product Class', valueGetter: tableHelper.getFieldKeyOrValue, width: 120, minWidth: 100, maxWidth: 140 },
    { field: 'VariantCount', headerName: 'Variant Count', },
    { field: 'IsPhysical', headerName: 'Physical', type: "boolean", },
    { field: 'IsDigital', headerName: 'Digital', type: "boolean", },
    { field: 'IsCustomerSpecific', headerName: 'Is Customer Specific', type: "boolean", },
    { field: 'ProductType_Key', headerName: 'Product Type Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 120,  type: "number" },
    
    //{ field: 'LowOrderPointsIds', headerName: "Low Order Points Id", valueGetter: additionalData['LowOrderPointsIds'].additionalDataCell, width: 200 },

  ];
  const fieldOrder = useGetColumnOrder(columnsArray)
  const reoderedColumns = reorderColumns(columnsArray, fieldOrder)
  const columns: GridColDef[] = React.useMemo(
    () => columnsArray,
   [  additionalData, tableSettings ],//warehouseColumns[manufacturerOptions, productLineOptions, productTypeOptions,statusOptions,
  );
  return columns;
}

const useGetColumnOrder = (columns, tableName = "ProductTable") => {
  const  {settings} = useSettingsContext()
  const savedOrder = getNestedValue(settings, ["TableColumnOrder", tableName]);
  const newFieldOrder = []
  columns.forEach((column) => {
    newFieldOrder.push(column?.field);
  });
  const [fieldOrder, setFieldOrder] = useState(newFieldOrder)
  useEffect(() => {
    if (savedOrder?.length == columns?.length) {
      setFieldOrder(savedOrder)
    }
  }, []);
  return (fieldOrder)
}

const reorderColumns = (columns, orderedColumFields) => {
  const reorderedColumns = [];
  orderedColumFields.forEach((orderedField) => {
    reorderedColumns.push(columns.find(columns => columns.field == orderedField))
  });
  return reorderedColumns
}

export const useProductsSelectTable = (): [columns: readonly  GridColDef[], tableSettings: tableSettingsProps] => {
  const {rows, status} = useGetAllProducts();
  //const manufacturerOptions = tableHelper.getSelectOptionsFromKeyValuePair(rows, "Manufacturer");
  //const productLineOptions = tableHelper.getSelectOptions(rows, "ProductLine");
  const tableName = "ProductSelectTable";
  const idPath = ID_FIELD_PRODUCTS;
  const columns: readonly  GridColDef[]= React.useMemo(
    () => [
       { field: 'ProductId', width: 75, headerName: 'Id', hideable: false, maxWidth: 85 },
       { field: 'Name',  headerName: 'Name', minWidth: 180, width: 190,  flex: 2, },
       { field: 'ProductStatus_Value', headerName: 'Status', cellClassName: tableHelper.statusColumn, valueGetter: tableHelper.getFieldKeyOrValue, renderCell: tableHelper.renderStatusCell , type: 'singleSelect', valueOptions:tableHelper.STATUSES.PRODUCTS},// valueOptions: statusOptions, },
      { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue, width: 130, maxWidth: 145 },
      { field: 'ProductType_Key', headerName: 'Product Type Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 120, maxWidth: 130 },
      { field: 'Manufacturer_Value', headerName: 'Manufacturer', valueGetter: tableHelper.getFieldKeyOrValue, minWidth: 150, maxWidth: 200 }, // type: 'singleSelect', valueOptions: manufacturerOptions,
      { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id', width: 190, minWidth: 180, maxWidth: 200 },
      { field: 'CountryOfOrigin_Value', headerName: 'Country Of Origin', valueGetter: tableHelper.getFieldKeyOrValue, width: 150, maxWidth: 200 },
      { field: 'TARIC', headerName: 'TARIC', width: 140, minWidth: 130, maxWidth: 150 },
      { field: 'ValidFrom', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid From', width: 115, minWidth: 110, maxWidth: 130 },
      { field: 'ValidTo', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid To', width: 115, minWidth: 110, maxWidth: 130 },
      { field: 'Manufacturer_Key', headerName: 'Manufacturer Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 125, minWidth: 100, maxWidth: 130 },
      { field: 'ProductStatus_Key', headerName: 'Status Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 80, minWidth: 70, maxWidth: 100 },
      { field: 'ProductSubClass_Value', headerName: 'Product Subclass', valueGetter: tableHelper.getFieldKeyOrValue, width: 130, minWidth: 100, maxWidth: 150 },
      { field: 'ProductLine_Value', headerName: 'Product Line', valueGetter: tableHelper.getFieldKeyOrValue, width: 180, minWidth: 160, maxWidth: 220 },// type: 'singleSelect', valueOptions: productLineOptions,
      { field: 'ProductClass_Value', headerName: 'Product Class', valueGetter: tableHelper.getFieldKeyOrValue, width: 120, minWidth: 100, maxWidth: 140 },
      { field: 'IsPhysical', headerName: 'Physical', type: "boolean", width: 80, minWidth: 70, maxWidth: 90 },
      { field: 'IsDigital', headerName: 'Digital', type: "boolean", width: 80, minWidth: 70, maxWidth: 90 },

    ],
    [],//manufacturerOptions, productLineOptions
  );
  let tableSettings = useTableSettings({ columns, idPath, rows, tableName, status});

  useEffect(() => {
    tableSettings.setRowSelectionModel([])
  }, [])
  tableSettings.hasToolbar = false;
  return [columns, tableSettings];
};

export const useProductsOnSalesItemsTable = (initialValues): [
  columns: GridColDef[],
  tableSettings: tableSettingsProps,
  changedProducts: any[],
  setChangedProducts: React.Dispatch<React.SetStateAction<any[]>>,
  showProductSelector: number | GridRowId,
  setShowProductSelector: React.Dispatch<React.SetStateAction<number | GridRowId>>
] => {
  const [changedProducts, setChangedProducts] = useState<any[]>([]);
  const [showProductSelector, setShowProductSelector] = useState<number | GridRowId>(-1);
  const rows = changedProducts;
  const idPath = ["ProductId"];
  let tableSettings;
  
  // Define your columns. (They remain largely the same.)
  const columns: GridColDef[] = React.useMemo(() => [
    {
      field: 'Edit',
      getActions: (params) =>
        tableHelper.buttonColumn(params, "Edit", "/products/products/edit?id=", "ProductId", "Edit Product"),
      type: 'actions',
      headerName: 'Edit',
      minWidth: 80,
      flex: 0.8,
    },
    { field: 'ProductId', headerName: 'Id', hideable: false },
    { ...GRID_CHECKBOX_SELECTION_COL_DEF, width: 100, headerName: 'Main Item', renderHeader: () => <>Main Item</> },
    { field: 'ProductStatus_Value', headerName: 'Status', cellClassName: tableHelper.statusColumn, valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ProductName', editable: true, headerName: 'Name' },
    { field: 'ManufacturerName', headerName: 'Manufacturer Name', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ManufacturerProductId', headerName: 'ManufacturerProductId' },
    { field: 'IsPhysical', headerName: 'Physical', type: "boolean" },
    { field: 'IsDigital', headerName: 'Digital', type: "boolean" },
    { field: 'ProductClass', headerName: 'Product Class', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ProductSubClass_Value', headerName: 'Product Subclass', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ProductValidFrom', minWidth: 180, type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'ValidFromDate' },
    { field: 'ProductValidTo', minWidth: 180, type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'ValidToDate' },
    { field: 'ProductType_Key', headerName: 'Product Type Id', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'ProductStatus_Key', headerName: 'Status Id', valueGetter: tableHelper.getFieldKeyOrValue },
    {
      field: 'actions',
      getActions: (params: GridRowParams) =>
        tableHelper.deleteButton(params, setChangedProducts, changedProducts, tableSettings),
      type: 'actions',
      headerName: 'Delete',
      minWidth: 80,
      flex: 0.8,
    },
  ], [changedProducts, setChangedProducts, tableSettings]);

  const tableName = "ProductsOnSalesItemsTable";
  tableSettings = useTableSettings({ columns, rows, idPath, tableName });

  // Pin the actions column (runs when rows change)
  useUpdateEffect(() => {
    tableSettings.setPinnedColumns({ right: ["actions"] });
  }, [rows]);

  // On initial load, set the products from the initialValues and select the Main Item.
  useUpdateEffect(() => {
    if (changedProducts?.length < 1) {
      setChangedProducts(initialValues?.Products ?? []);
      const mainProduct = initialValues?.Products?.find((product) => product?.MainItem);
      if (mainProduct) {
        tableSettings.setRowSelectionModel([mainProduct.ProductId]);
      }
    }
  }, [initialValues?.Products]);

  // When the table's row selection changes, update the product objects in state to mark the Main Item.
  // (We update only if there is a genuine change.)
  useEffect(() => {
    const selection = tableSettings.rowSelectionModel; // Assume this is updated by your grid.
    if (selection && selection.length > 0) {
      const mainId = selection[0];
      setChangedProducts((prevProducts) => {
        // Only update if the MainItem flag differs.
        const updatedProducts = prevProducts.map((product) => {
          const shouldBeMain = product.ProductId === mainId;
          if (product.MainItem !== shouldBeMain) {
            return { ...product, MainItem: shouldBeMain };
          }
          return product;
        });
        return updatedProducts;
      });
    }
    // Note: Ensure that tableSettings.rowSelectionModel is stable and only changes when user changes selection.
  }, [tableSettings.rowSelectionModel]);

  // Configure additional table settings.
  tableSettings.checkboxSelection = true;
  tableSettings.selectOnlyOneRow = true;
  tableSettings.disableSelectionOnClick = true;
  tableSettings.autoHeight = true;
  tableSettings.hasToolbar = false;
  tableSettings.loading = false;

  return [columns, tableSettings, changedProducts, setChangedProducts, showProductSelector, setShowProductSelector];
};









// const extractCampaignCellData = (params, additionalRows) => {
//   let cellData = 0;
//   const matchingRows = additionalRows?.ReportRows?.filter(campaingRow => campaingRow.ArticleNumber == params.id);
//   matchingRows?.forEach(row => {
//     cellData += parseInt(row?.QuantitySold ?? 0);
//   })
//   return cellData;
// }

// const extractLowOrderPointCellData = (value, row, column, apiRef, additionalRows) => {

//   let cellData = null;

//   // Find the rule that contains the product
//   const matchingRule = additionalRows?.find(rule =>
//     rule.LowOrderPointRows?.some(orderPointRow => orderPointRow.ArticleNumber == row?.ProductId)
//   );

//   if (!matchingRule) return null; // No matching rule found

//   // Find the specific order point row
//   const matchingRows = matchingRule.LowOrderPointRows?.filter(orderPointRow => orderPointRow.ArticleNumber == row?.ProductId);

//   if (matchingRows?.length > 0) {
//     //console.log(matchingRows, matchingRule);
//     matchingRows.forEach(orderPointRow => {
//       cellData = `Rule: "${matchingRule.Name}" order ${orderPointRow.OrderQuantity} when below ${orderPointRow.ThresholdQuantity}`;
//     });
//   }

//   return cellData;
// };

// const extractLowOrderPointIdCellData = (value, row, column, apiRef, additionalRows) => {
//   let cellData = null;
//   const matchingRows = additionalRows?.filter(row =>
//     row.LowOrderPointRows?.some(orderPointRow => orderPointRow.ArticleNumber == row.id)
//   );

//   matchingRows?.forEach(row => {
//     cellData = row.Id
//   })
//   return cellData;
// }


// const extractWarehouseStockCellData = (value: { name: string }, row, column, apiRef, additionalRows) => {
//  // console.log(value, row, column, apiRef, additionalRows)

//   const currentWarehouseId = column?.field?.split("_")[1] ?? '1';
//   const isTotal =  column?.field?.split("_")[2] == "Total" ?? false;
//   const cellData = additionalRows != null ? isTotal ? additionalRows[String(row.id)]?.[String(currentWarehouseId)]?.WarehouseQty ?? 0 : additionalRows[String(row.id)]?.[String(currentWarehouseId)]?.AvailableQty ?? 0 : 0;

//   return cellData;
// }


// interface AttributesObject {
//   [key: string]: {
//     Value: string;
//     Name: string;
//     Unit:string;
//   };
// }
// const extractAttributesCellData = (params, additionalRows) => {
//   if(params?.id == "106996"){
//   }
  
//   const convertToString = (obj: AttributesObject): string => {
//     return Object.entries(obj).map(([key, { Name, Value, Unit }]) => {
//       // Regular expression to match a comma followed by any number of zeros at the end of a string
//       const trimmedValue = Value.replace(/,0+$/, '');
//       return `${Name}:${trimmedValue}${Unit == 'null' ? '' : Unit ?? ''}`;
//     }).join(', ');
//   };
  
  

//   const cellData = additionalRows[params.id] != null ?  convertToString(additionalRows[params.id]) : "";
 
//   return cellData;
// }


